import React, { useState } from 'react';

import { Col } from 'react-bootstrap';

import DistributorFilter from 'components/shared/DistributorFilter';
import SkuMappingWorkflow from 'components/sku_mapping_workflow/SkuMappingWorkflow';
import { SkuMappingWorkflowTypes } from 'lib/enums/SkuMappingWorkflowEnum';

function SkuMappingWorkflowEnrichVendor() {
  const [selectedVendorId, setSelectedVendorId] = useState(null);

  return (
    <>
      <Col sm={4}>
        <DistributorFilter
          updateSelectedVendorId={option => setSelectedVendorId(option)}
          label="Filter by distributor"
          selectedOption={selectedVendorId}
        />
      </Col>
      {selectedVendorId && (
        <SkuMappingWorkflow
          workflowType={SkuMappingWorkflowTypes.VENDOR}
          workflowValue={selectedVendorId.value}
        />
      )}
    </>
  );
}

export default SkuMappingWorkflowEnrichVendor;
